import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { useSelector, useDispatch } from 'react-redux'

import mapboxgl from 'mapbox-gl';

const EMPTY_GEOJSON_DATA = {
  "type": "Feature", "properties": { "icon": "marker1" },
  "geometry": { "type": "Point", "coordinates": [] }
}

/**
 * Draws and removes the geojson lines extracted from the the json definition 
 * on the map. 
 */
export default function ExtraMapLineFeatures(props) {
  // TODO: lines can be concatenated into one when too many are present 
  // (e.g. keknap did that) - define a parameter to do so
  // const lineLayerId = 'geoJsonLines'

  const map = useSelector((state) => state.ui.map) ;

  const features = useSelector((state) => state.viewport.extraMapFeatures) ;
  const featuresVisibility = useSelector((state) => state.viewport.extraMapFeaturesVisibility)
  const geoJsons = useSelector((state) => state.viewport.geoJsons) ;
  const mapStyle = useSelector((state) => state.ui.mapStyle) ;
  const mapStyleLoading = useSelector((state) => state.ui.mapStyleLoading) ;
  const firstIdleTime = useSelector((state) => state.ui.firstIdleTime) ;

  // const geoJsonsKeysRef = useRef(new Set())  
  
  // const popupRef = useRef(null)
  
  // to check if initialization was done
  const isInitializedRef = useRef(false)
  const isInitiallyZoomedRef = useRef(false)

  const concatGeoJSONFeatures = (g1, g2) => {
    if (g1==null) return g2 
    if (g2==null) return g1
    const ret =  ( { 
        "type" : "FeatureCollection",
        "features": [... g1.features, ... g2.features]
    })
    //console.log("merged geojson length: ", Object.keys(ret['features']).length )
    return ret ; 
  }
  

  // initialization / descruction: 
  useEffect(() => {
    // console.log('USEEFFECT: ExtraMapLineFeatures')

    if ( map && ( ! mapStyleLoading) && features && Object.keys(features).length > 0) {
      // layers are already set up 
      // collect line features of layers: 
      var layerFeatures = {}
      // use only the geojsons not already added: 
      Object.keys(geoJsons)
      var fitbs ; 
      for (var i = 0; i < features.items.length; i++) {
        const item = features.items[i] 
        if (props.initialSubview==item.key) {
          // console.log('HOOO: ', item.fitToBounds)
          fitbs = item.fitToBounds 
        }
        
        // console.log('features[', i, ']: ', ', geojson: ', geoJsons[item.key] )

        if ("lineGeoJsonUrl" in item && geoJsons[item.key] && featuresVisibility[item.key]) {
          if ( ! item.layerId) {
            console.log("extra map feature has no layerId (key: " + item.key + ")")
            break ;
          }
          if (! item.layerId in layerFeatures) {
            //console.log('ExtraMapLineFeatures: add to new layer ', item.layerId, ' = ', item.key)
            layerFeatures[item.layerId] = geoJsons[item.key]
          }
          else {
            //console.log('concatGeoJSONFeatures: concatGeoJSONFeatures ', item.layerId, ' += ', item.key)
            layerFeatures[item.layerId] = concatGeoJSONFeatures(
                                            layerFeatures[item.layerId], geoJsons[item.key])
          }
        } 
      }

      // add collected features to map: 
      Object.entries(layerFeatures).forEach( ([key, value]) => {
        // console.log('map.getsource(', key, ').setData(', value, ')')
        const src = map.getSource(key) 
        if (typeof src === 'undefined') {
          console.log('Map source not found for key: ', key) 
          // console.log('setting line layer data for "', key, '", size: ', value.features.length, 
          //             '; map has layer:', map.getLayer()!== 'undefined') 
        }
        else {
          // // avoid congestion (see https://github.com/mapbox/mapbox-gl-js/issues/3692)          
          src.setData(value) ;
          // fix not working: forced repaing
          // map.triggerRepaint();
        }
      } );
      if ( (! isInitiallyZoomedRef.current) && map && fitbs) {
        // console.log("fitBounds: ", fitbs)
        map.fitBounds(fitbs,  { padding: 100 } )
        isInitiallyZoomedRef.current = true
      }
        
      
      //for (var i = 0; i > 0; i++) { 
      //  const item = layerFeatures[i] 
      //  // lines: 
      //  if (featuresVisibility[item.key] && geoJsons[item.key]) {
      //    if ( (! isInitiallyZoomedRef.current) && item.fitToBounds ) {
      //      console.log("fitBounds")
      //      map.fitBounds(item.fitToBounds)
      //      isInitiallyZoomedRef.current = true
      //    }
      //  }
      //}
      isInitializedRef.current = true
    }
    else {
      // console.log('Early map drawing attempt of ExtraMapLineFeatures.')
    }
    return () => {
      // console.log('ExtraMapLineFeatures: cleaning up line feature map data.')
      // cleanup 
      if (layerFeatures && map) { 
        Object.entries(layerFeatures).forEach( ([key, value]) => {
          try {
            map.getSource(key).setData( EMPTY_GEOJSON_DATA) ;
          } catch (error) {
            // console.log("ERROR:", error);
            // expected output: ReferenceError: nonExistentFunction is not defined
            // Note - error messages will vary depending on browser          
            //console.log('ereasing line layer data for: ', key)
          }
          // else console.warn('Map source not found for key: ', key)
        } );  
      }

    }
  }, [map, features, featuresVisibility, geoJsons]); // mapStyleLoading,


  return null ;
}
